import { useEffect } from "react";
import CmsBanner from "../../components/Banner/CmsBanner";
import BlueBtn from "../../components/button/PrimaryBtn";
import { useCmsPage } from "../../hooks/useCms";
import Loader from "../../components/Loader/Loader";
import { useTranslation } from "react-i18next";
export default function About() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const { page, isLoading, isError } = useCmsPage("about_us");



  useEffect(() => {
    const handleResize = () => {
      const body = document.body;

      if (window.innerWidth >= 2400) {
        body.classList.add("scale-wrapper");
      } else {
        body.classList.remove("scale-wrapper");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isLoading) {
    return (
      <div className="wrapper bg-primary-ivory">
        <CmsBanner
          title={t("about.title")}
          classNameShape="hidden"
        />
        <section className="lg:py-[7vw] py-10 pb-22 bg-transparent relative  2xl:-mt-[2.24vw] -mt-11 z-10 ">
          <div className="w-full 2xl:max-w-[50vw] max-w-[900px] mx-auto px-4 relative z-20">
            <div className="flex flex-col items-center justify-center py-20">
              <Loader />
              <p className="mt-4 text-gray-600 text-lg font-medium">{t("about.loading")}</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  if (isError || !page || !page.content) {
    return (
      <div className="wrapper bg-primary-ivory">
        <CmsBanner
          title={t("about.title")}
          classNameShape="hidden"
        />
        <div className="w-full max-w-[900px] fullhd:max-w-[1100px] mx-auto px-4 relative z-20">
          <div className="flex flex-col items-center justify-center py-20">
            <p className="mt-4 text-gray-600 text-lg font-medium">{t("about.notAvailable")}</p>
            <p className="mt-4 text-gray-600 text-lg font-medium">{t("about.notAvailableDescription")}</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="wrapper bg-primary-ivory">
      <CmsBanner title={page?.title} description={page?.description} classNameShape="hidden" />
      <div className="wrapper">
        <section className="lg:py-[7vw] py-10 pb-22 bg-transparent relative  2xl:-mt-[2.24vw] -mt-11 z-10 ">
          <div className="w-full 2xl:max-w-[50vw] max-w-[900px] mx-auto px-4 relative z-20">
            <div className="">
              <div
                className={`prose max-w-none ${isArabic ? "rtl text-right" : "ltr text-left"}`}
                dir={isArabic ? "rtl" : "ltr"}
              >
                <div dangerouslySetInnerHTML={{ __html: page?.content }} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}


{/* <section className="lg:py-[7vw] py-10 pb-22 bg-transparent relative  2xl:-mt-[2.24vw] -mt-11 z-10 ">
<div className="w-full 2xl:max-w-[50vw] max-w-[900px] mx-auto px-4 relative z-20">
  <div className="text-center">
    <svg
      className="w-16 h-16 mx-auto text-gray-400"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.801 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.801 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
      />
    </svg>
    <h3 className="mt-4 text-xl font-medium text-gray-900">{t("about.notAvailable")}</h3>
    <p className="mt-2 text-gray-700 max-w-md mx-auto">{t("about.notAvailableDescription")}</p>
  </div>
</div>
</section>
<section>
<div className="lg:border-s-[0.208vw] border-s-4 border-primary 2xl:ps-[0.833vw] ps-4 2xl:mb-[1.25vw] mb-6">
  <h2 className="2xl:text-[1.042vw]/tight text-xl/tight font-bold text-black-900">
    {t("about.dataSecurity")}
  </h2>
</div>

<div className="border-b border-[#E2E2E2] 2xl:pb-[1.042vw] pb-5 2xl:mb-[1.667vw] mb-8">
  <p className="text-gray-600 2xl:text-[0.833vw] text-base/tight 2xl:mb-[0.625vw] mb-3">
    {t("about.dataSecurityDescription")}
    Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable
    means to protect your Personal Data, we cannot guarantee its absolute security.
  </p>
</div>
</section>
<section>
<div className="lg:border-s-[0.208vw] border-s-4 border-primary 2xl:ps-[0.833vw] ps-4 2xl:mb-[1.25vw] mb-6">
  <h2 className="2xl:text-[1.042vw]/tight text-xl/tight font-bold text-black-900">
    {t("about.changesToThisPrivacyPolicy")}
  </h2>
</div>

<div className="border-b border-[#E2E2E2] 2xl:pb-[1.042vw] pb-5 2xl:mb-[1.667vw] mb-8">
  <p className="text-gray-600 2xl:text-[0.833vw] text-base/tight 2xl:mb-[0.625vw] mb-3">
    {t("about.changesToThisPrivacyPolicyDescription")}
  </p>
</div>
</section>
<section>
<div className="lg:border-s-[0.208vw] border-s-4 border-primary 2xl:ps-[0.833vw] ps-4 2xl:mb-[1.25vw] mb-6">
  <h2 className="2xl:text-[1.042vw]/tight text-xl/tight font-bold text-black-900">
    {t("about.contactUs")}
  </h2>
</div>

<div className="border-b border-[#E2E2E2] 2xl:pb-[1.042vw] pb-5 2xl:mb-[1.667vw] mb-8">
  <p className="text-gray-600 2xl:text-[0.833vw] text-base/tight 2xl:mb-[0.625vw] mb-3">
    {t("about.contactUsDescription")}
  </p>
  <ul className="text-gray-600">
    <li className="flex items-start 2xl:text-[0.833vw] text-base/tight 2xl:ps-[0.417vw] ps-2">
      <span className="lg:me-[0.417vw] me-2">•</span>
      <span>{t("about.contactUsEmail")}</span>
    </li>
    <li className="flex items-start 2xl:text-[0.833vw] text-base/tight 2xl:ps-[0.417vw] ps-2">
      <span className="lg:me-[0.417vw] me-2">•</span>
      <span>{t("about.contactUsWebsite")}</span>
    </li>
  </ul>
</div>
</section>
<section>
<div className="lg:border-s-[0.208vw] border-s-4 border-primary 2xl:ps-[0.833vw] ps-4 2xl:mb-[1.25vw] mb-6">
  <h2 className="2xl:text-[1.042vw]/tight text-xl/tight  font-bold text-black-900">
    {t("about.needMoreHelp")}
  </h2>
</div>

<div className="flex sm:flex-row flex-col lg:gap-[0.625vw] gap-3 items-center sm:justify-between justify-start">
  <p className="text-gray-600 2xl:text-[0.833vw] text-base/tight 2xl:text-lg/tight 2xl:mb-[0.625vw] mb-3 text-start sm:w-fit w-full">
    {t("about.needMoreHelpDescription")}
  </p>
  <BlueBtn to="/contact-us">{t("about.contactUs")}</BlueBtn>
</div>
</section> */}